<div class="container-fluid p-0">
  <div class="d-flex" style="height: 100vh">
    <div class="sidebar d-flex flex-column align-items-center Nav navbar p-0" style="width: 4rem">
      <img id="img1" src="assets/LayoutIcon/Logo Icon.svg" class="img-fluid mt-3 mb-4" data-bs-toggle="tooltip"
        data-bs-placement="right" title="Logo" />

      <a routerLink="dashboard" (click)="messages = 'Dashboard'">
        <img class="img2" routerLinkActive="active-link" src="assets/LayoutIcon/dash2.svg" data-bs-toggle="tooltip"
          data-bs-placement="right" title="Dashboard" />
      </a>

      <a routerLink="user" (click)="messages = 'User Management'">
        <img class="img2" routerLinkActive="active-link" src="assets/LayoutIcon/user2.svg" data-bs-toggle="tooltip"
          data-bs-placement="right" title="User Management" />
      </a>

      <a routerLink="booking" (click)="messages = 'Booking Management'">
        <img class="img2" routerLinkActive="active-link" src="assets/LayoutIcon/booking2.svg" data-bs-toggle="tooltip"
          data-bs-placement="right" title="Booking Management" />
      </a>

      <a routerLink="finance" (click)="messages = 'Financial Overview'">
        <img class="img2" routerLinkActive="active-link" src="assets/LayoutIcon/fin2.svg" data-bs-toggle="tooltip"
          data-bs-placement="right" title="Financial Overview" />
      </a>
<!-- 
      <a routerLink="helpsupport" (click)="messages = 'Help & Support'">
        <img class="img2" routerLinkActive="active-link" src="assets/LayoutIcon/help2.svg" data-bs-toggle="tooltip"
          data-bs-placement="right" title="Help & Support" />
      </a> -->

      <div class="secImage d-flex flex-column align-items-center mt-auto mb-3">
        <a routerLink="contentmanager" (click)="messages = 'Content Manager'">
          <img class="downimg" style="padding: 13px;" routerLinkActive="active-link" src="assets/LayoutIcon/ic-cms.svg"
            data-bs-toggle="tooltip" data-bs-placement="right" title="Content Manager" />
        </a>

        <a routerLink="subsetting" (click)="messages = 'Settings'">
          <img class="downimg" routerLinkActive="active-link" src="assets/LayoutIcon/set2.svg" data-bs-toggle="tooltip"
            data-bs-placement="right" title="Settings" />
        </a>

        <img (click)="logout()" class="downimg" src="assets/LayoutIcon/log2.svg" data-bs-toggle="tooltip"
          data-bs-placement="right" title="Logout" />
      </div>
    </div>


    <div class="flex-grow-1 d-flex flex-column" style="overflow: hidden;">
      <div class="bg-white border-bottom d-flex justify-content-between align-items-center px-4" id="heightl"
        style="height: 8vh">
        <h5 class="m-0">
          <img src="assets/LayoutIcon/Breadcrumb Icon.svg" /> {{ messages }}
        </h5>
        <div class="d-flex align-items-center h-100">
          <div class="icon"> <img class="img-fluid" src="assets/LayoutIcon/Icon.svg" /> </div>
          <a >
            <img src="{{profileImage}}" alt="User" class="rounded-circle" width="50" height="50" /> </a>
          <div class="Navuser">
            <a  class="d-flex">
              <h5 class="text-truncate" style="max-width: 150px; ">
                {{displayName}}
                

              </h5>
           
            </a>
            <div>
              <a >
                <h5 style="color: #888888">Admin</h5>
              </a>
            </div>
          </div>

        </div>
      </div>
      <app-confirmation-dialoge></app-confirmation-dialoge>
      <div class="containers">
     <router-outlet> </router-outlet>
  
      </div>

    </div>
  </div>
</div>